



















































import { PropType } from "vue";

interface Dimensions {
  width?: string | number;
  height?: string | number;
}

interface Data {
  url: string;
  src: string;
  title: string;
  dimensions: Dimensions | null;
}

export default {
  inheritAttrs: false,
  props: {
    data: {
      type: Object as PropType<Data>,
      default: () => ({
        url: "",
        src: "",
        title: "",
        dimensions: {
          width: undefined,
          height: undefined,
        },
      }),
    },
    src: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: undefined,
    },
    height: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      image: this.data as Data,
    };
  },
  computed: {
    /**
     * @todo check precedence of size values. Should custom be first?
     */
    finalWidth() {
      return this.width || this.image?.dimensions?.width || "100%";
    },
    finalHeight() {
      return this.height || this.image?.dimensions?.height;
    },
    finalText() {
      return this.image?.title || "";
    },
  },
  watch: {
    src: function(newValue: string) {
      this.image.src = newValue;
    },
    data: function(newValue: any) {
      this.image = newValue;
    },
  },
};
